import { colors } from '@ui/colors'
import { Status } from './types'

export const colorStatus: Record<Status, { front: string; back: string }> = {
  default: {
    front: colors.text,
    back: colors.gray[75],
  },
  active: {
    front: colors.blue[600],
    back: colors.blue[100],
  },
  disabled: {
    front: colors.black25,
    back: colors.white,
  },
}
